<script setup>
// Imports
import { getDialogIcon } from 'src/utils/servicePresentation'

// Props
const props = defineProps({
  title: { type: String, default: '' },
  subtitle: { type: String, default: '' },
  recordName: { type: String, default: '' },
  icon: { type: String, default: null },
  itemsService: { type: String, default: null },
})

// Computed
const headerIcon = computed(() => props.icon || getDialogIcon(props.itemsService))
</script>

<template>
  <!-- Shared dialog heading; callers retain their close and maximize actions. -->
  <div class="omni-dialog-header row items-center no-wrap">
    <q-avatar v-if="headerIcon" color="primary" text-color="white" size="48px" class="rounded-borders q-mr-md">
      <q-icon :name="headerIcon" size="26px" />
    </q-avatar>
    <slot name="leading" />
    <div class="col min-width-0">
      <div class="omni-dialog-heading" role="heading" aria-level="2">
        <slot>{{ title }}</slot>
      </div>
      <div v-if="recordName" class="omni-dialog-subtitle text-body1 q-mt-xs ellipsis" :title="recordName">{{ recordName }}</div>
      <div v-else-if="subtitle" class="omni-dialog-subtitle text-body1 q-mt-xs">{{ subtitle }}</div>
    </div>
    <div class="row items-center no-wrap q-ml-sm"><slot name="actions" /></div>
  </div>
</template>
